import React, {FC} from 'react'
//@ts-ignore
import LKGrid from 'shared/LKGrid'

import config from './LKGridConfig'
import { ReserveAutoProps } from 'src/features/LoanDetails/types.LoanDetails'

const ReserveAuto: FC<ReserveAutoProps> = ({ data, instanceName, disabled }) => (
  <LKGrid instanceName={instanceName} rowData={data} disabled={disabled} {...config} />
)

export default ReserveAuto
